import {
  selectors as bbbSelectors,
  operations as bbbOperations,
} from '../../store/bbb';
import { operations as toastOperations } from '../../store/toasts';

const launchMeeting = ({ id, context }) => async (dispatch, getState) => {
  if (bbbSelectors.isFetchingJoinUrl(getState())) {
    return;
  }

  const url = await dispatch(bbbOperations.fetchJoinUrl({ id, context }));
  if (url) {
    window.open(url, '_blank');
  } else {
    dispatch(
      toastOperations.showToast({
        emoji: '🤔',
        message: 'Oops! We failed to launch the BigBlueButton session',
      })
    );
  }
};

export default launchMeeting;
